// Wave 10.1 (Vania 1 Oct · update) — the currency code is always written "KES"
// in full capitals, everywhere in the app. The rest of the price line stays
// lowercase. Any `text-transform: lowercase` on a parent is bypassed via the
// `.ww-currency` class (set in index.css: `text-transform: none !important`).
import React from "react";

// WW-184 / WW-186 · currency codes written in capitals; thousands always with commas.
export const CURRENCY_CODES = ["KES", "USD", "EUR", "GBP", "UGX", "TZS", "RWF", "ZAR", "NGN", "AED", "INR"];
export const CURRENCY_SPLIT = new RegExp(`\\b(${CURRENCY_CODES.join("|")})\\b`, "g");

export function eventCurrency(ev) {
  const c = String(ev?.price_currency || "").toUpperCase();
  if (CURRENCY_CODES.includes(c) && c !== "KES") return c;
  const m = String(ev?.price || "").match(new RegExp(`\\b(${CURRENCY_CODES.join("|")})\\b`, "i"));
  return m ? m[1].toUpperCase() : (c || "KES");
}

export function withCommas(str) {
  return String(str || "").replace(/\b\d{4,}\b/g, (n) => Number(n).toLocaleString("en-US"));
}

/** Uppercase any currency code (case-insensitive) in a free-text price
 *  string and add thousands commas, so "kes 1500" renders as "KES 1,500". */
export function upperKES(str) {
  if (!str) return "";
  return withCommas(String(str).replace(new RegExp(`\\b(${CURRENCY_CODES.join("|")})\\b`, "gi"), (c) => c.toUpperCase()));
}

/** Render a free-text price string with KES forced uppercase AND wrapped in
 *  `.ww-currency` so it survives inside lowercase-styled buttons. */
export function PriceText({ children }) {
  const text = upperKES(children);
  if (!text) return null;
  const parts = text.split(CURRENCY_SPLIT);
  return (
    <>
      {parts.map((p, i) =>
        CURRENCY_CODES.includes(p)
          ? <span key={i} className="ww-currency">{p}</span>
          : <React.Fragment key={i}>{p}</React.Fragment>
      )}
    </>
  );
}
